import {Component, effect, inject, OnInit} from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {IonButton, IonContent, IonImg} from "@ionic/angular/standalone";
import {FooterComponent} from "../../common/footer/footer.component";
import {LanguageService} from '../../core/language.service';
import {addIcons} from 'ionicons';
import {extensionPuzzleOutline, peopleOutline, ribbonOutline, serverOutline} from 'ionicons/icons';
import {pages} from '../../configs/config';
import {JobsService} from './jobs.service';

@Component({
    selector: 'app-careers',
    templateUrl: './careers.component.html',
    styleUrls: ['./careers.component.scss'],
  imports: [
    HeaderComponent,
    IonContent,
    FooterComponent,
    IonImg,
    IonButton,
  ]
})
export class CareersComponent  implements OnInit {
  languageService: LanguageService = inject(LanguageService);
  jobsService: JobsService = inject(JobsService);
  content: any;
  jobs: any = [];
  constructor() {
    addIcons( { ribbonOutline, extensionPuzzleOutline, serverOutline, peopleOutline });
    effect(async () => {
      if (this.languageService.lang()) {
        this.content = await this.languageService.loadContent(pages.careers);
      }
    })
  }
  async ngOnInit() {
    this.content = await this.languageService.loadContent(pages.careers);
    this.jobs = await this.jobsService.getAllJobs();
  }

}
